import { jsx as _jsx } from "react/jsx-runtime";
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { NO_DATA_LANG_LABEL } from '../../constants/ads';

const getAmountSpentForAdCampaign = (adSpendPerCampaign, adCampaignId) => {
  if (!adSpendPerCampaign || !adSpendPerCampaign.get(adCampaignId) || isNaN(adSpendPerCampaign.get(adCampaignId).adSpend)) {
    return 0;
  }

  return adSpendPerCampaign.get(adCampaignId).adSpend;
};

export default function CostPerCampaignLabel({
  adSpendPerCampaign,
  adCampaignId,
  goalTypeDataObject
}) {
  const amountSpentForAdCampaign = getAmountSpentForAdCampaign(adSpendPerCampaign, adCampaignId);
  const goalTypeDataObjectNotValid = !goalTypeDataObject || !goalTypeDataObject.value || isNaN(goalTypeDataObject.value);
  if (amountSpentForAdCampaign === 0) return /*#__PURE__*/_jsx("span", {
    "data-test-id": "cost-per-campaign-label",
    children: /*#__PURE__*/_jsx(FormattedCurrency, {
      currencyCode: goalTypeDataObject.format,
      value: 0
    })
  });

  if (goalTypeDataObjectNotValid) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "cost-per-campaign-label",
      message: NO_DATA_LANG_LABEL
    });
  }

  const costPerValue = amountSpentForAdCampaign / goalTypeDataObject.value;
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": "cost-per-campaign-label",
    children: /*#__PURE__*/_jsx(FormattedCurrency, {
      currencyCode: goalTypeDataObject.format,
      "data-test-id": "cost-per-campaign-label",
      value: costPerValue
    })
  });
}
CostPerCampaignLabel.propTypes = {
  adSpendPerCampaign: PropTypes.object.isRequired,
  adCampaignId: PropTypes.string.isRequired,
  goalTypeDataObject: PropTypes.object.isRequired
};